import * as React from 'react';
import { Button } from 'web-shared/components';
import { startAbSignIn } from '../../lib/abSignIn';

interface Props {
    /** Same-site path to return to once signed in */
    returnPath: string;
}

/**
 * Sign-in for Autobooks employees, who are SSO-only: sends them through Microsoft
 * sign-in on the admin site (staging admin for *.dev.rcgiltner.com) and back to
 * `returnPath` on this site, signed in as themselves.
 */
export const AbSignInButton: React.FC<Props> = ({ returnPath }) => {
    const [busy, setBusy] = React.useState(false);

    function _click() {
        setBusy(true);
        startAbSignIn(returnPath);
    }

    return <div className="root">
        <style jsx>{`
            .root { max-width: 350px; margin: 24px auto 0; text-align: center; }
        `}</style>
        <Button size="small" color="white" fullWidth disabled={busy} loading={busy} onClick={_click}>
            Autobooks Employees
        </Button>
    </div>;
};
